import React, { memo } from 'react';
import { View } from 'react-native';
import { useLocale } from '@redlink/assets/locale';
import { createUseStyle } from '@redlink/assets/styles';
import { IconLookingForJob, Text } from '@redlink/components/atoms';

export const PreviewResumeJobStatus = memo(() => {
  const { styles, colors } = useStyle();
  const { dictionary } = useLocale();
  return (
    <View style={styles.contentContainer}>
      <IconLookingForJob size={24} color={colors.title} />
      <Text style={styles.title}>{dictionary.openToWork}</Text>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  contentContainer: {
    flexDirection: 'row',
    padding: 12,
    borderRadius: 10,
    backgroundColor: colors.cardBackground,
    alignItems: 'center'
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.title,
    marginStart: 10,
  },
}));
